import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react"; // 🔥 useEffect ekledik
import { stillValid, useAuth } from "./AuthProvider";
import { hasPermissionForPath } from "./hasPermissions";

const LOGIN_PATH = "/ctrl/authentication/login/creative";

const ProtectedRoute = () => {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();
  const { isAuth } = useAuth();
  const role = localStorage.getItem("userRole");
  const isSuper = role === "superadmin" || role === "3";

  // 🔥 DİL SENKRONİZASYONU
  useEffect(() => {
    const params = new URLSearchParams(search);
    const langInUrl = params.get("lang");
    const langInStorage = localStorage.getItem("admin_lang") || "tr";

    if (!langInUrl) {
      // Eğer URL'de dil yoksa, hafızadaki dili URL'ye ekle
      params.set("lang", langInStorage);
      // replace: true ile geçmişte (history) gereksiz kalabalık yapmıyoruz
      navigate(`${pathname}?${params.toString()}`, { replace: true });
    } else if (langInUrl !== langInStorage) {
      // Eğer URL'deki dil el ile değiştirildiyse, hafızayı güncelle
      localStorage.setItem("admin_lang", langInUrl);
    }
  }, [pathname, search, navigate]);

  /* token hiç yoksa — hard redirect (Navigate ilk yüklemede çalışmıyor) */
  if (!stillValid()) {
    window.location.href = LOGIN_PATH;
    return null;
  }

  /* auth henüz belirlenmedi */
  if (isAuth === undefined) return null;

  /* profil doğrulanamadıysa */
  if (!isAuth) {
    window.location.href = LOGIN_PATH;
    return null;
  }

  /* yol yetkisi */
  if (!isSuper && !hasPermissionForPath(pathname))
    return <Navigate to="/authentication/404/creative" replace />;

  return <Outlet />;
};

export default ProtectedRoute;